import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimations} from '@angular/platform-browser/animations';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {environment} from '../environments/environment';
import {provideAuth, getAuth} from "@angular/fire/auth";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpClient, provideHttpClient, withFetch} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideAngularSvgIcon} from "angular-svg-icon";
import {provideQuillConfig} from "ngx-quill";
import {defer} from "rxjs";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideAngularSvgIcon(),
    provideHttpClient(withFetch()),
    importProvidersFrom(TranslateModule.forRoot({
      defaultLanguage: "de",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideQuillConfig({
      customOptions: [{
        import: 'formats/font',
        whitelist: ['roboto', 'mirza', 'aref', 'serif', 'sansserif', 'monospace']
      }],
      customModules: [{
        path: 'modules/clipboard',
        // Plain-text paste with whitespace sanitization for every editor of the app.
        // Provided as Observable so ngx-quill resolves it lazily and Quill stays in its lazy chunk.
        implementation: defer(() => import('../util/quill-clipboard').then((m) => m.PlainTextClipboard))
      }],
      // Suppresses Quill's "Overwriting modules/clipboard" warning – overwriting is intended.
      suppressGlobalRegisterWarning: true
    }),
    { provide: LOCALE_ID, useValue: 'de-DE' }
  ],
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}
